import type { DocumentType as UploadDocumentType } from "@highnoteplatform/internal-sdk";
import type { DocumentUploadSdkConfig } from "@highnoteplatform/types";

import { documentUploadClient } from "./documentUploadClient";
import { mapError } from "./errorHandler";

export const fetchUploadLink = async (
  config: DocumentUploadSdkConfig,
  documentType: UploadDocumentType
): Promise<string | undefined> => {
  const client = documentUploadClient(config);
  const { onError, documentUploadSessionId } = config;
  try {
    const { data } = await client.createDocumentUploadLink({
      input: {
        documentUploadSessionId,
        documentType,
      },
    });
    const payload = data.createDocumentUploadLink;

    if (
      payload?.__typename === "DocumentUploadLink" &&
      payload.uploadUrl !== undefined
    ) {
      return payload.uploadUrl;
    }
  } catch (error) {
    mapError(error, onError);
  }

  return undefined;
};
